import { Component, Input } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { DISTRIBUTION_LIST_MOCK } from '@reenstudio/app/core/mock/incentive/distribution-mock';
import { AbstractListComponent } from '@reenstudio/app/shared/components/abstract-list/abstract-list.component';

@Component({
  selector: 'app-distribution-page',
  templateUrl: './distribution-page.component.html',
  styleUrls: ['./distribution-page.component.scss'],
})
export class DistributionPageComponent extends AbstractListComponent {
  @Input() override displayedColumns = ['date', 'name', 'reason', 'amount'];

  override dataTable: MatTableDataSource<{}>;

  statuses: any = {
    active: {
      color: 'success',
    },
    unactive: {
      color: 'error',
    },
  };

  constructor() {
    super();
    this.dataTable = new MatTableDataSource<{}>([]);
  }

  protected override getList() {
    return (this.dataTable.data = DISTRIBUTION_LIST_MOCK);
  }
}
